import React from "react";

import styles from "@src/reporting/Reporting.module.styl";

const KpiCard = ({ icon: Icon, label, value, detail = null }) => (
  <div className={styles.kpiCard}>
    <div className={styles.kpiIcon}><Icon fontSize="small" /></div>
    <div className={styles.kpiBody}>
      <div className={styles.kpiLabel}>{label}</div>
      <div className={styles.kpiValue}>{value}</div>
      {detail ? <div className={styles.kpiDetail}>{detail}</div> : null}
    </div>
  </div>
);

export default KpiCard;
